/* eslint-disable import/no-extraneous-dependencies */
import axios from 'axios';

interface RefreshTokenResponse {
  msg: string;
}

interface RefreshTokenResponseData {
  refId?: string;
}

interface SessionResponseData {
  id?: string;
}

interface SessionState {
  id?: string;
  refreshToken?: string;
  expireAt?: number;
}

export const signOut = () => {
  document.body.classList.remove('modalOpen');
  sessionStorage.removeItem('session');
  sessionStorage.removeItem('loginType');
  sessionStorage.removeItem('domain');
  sessionStorage.removeItem('Session-id');
  window.location.href = `/api/auth/logout`;
};

export const timeOut = () => {
  signOut();
};

export const refreshTokenService = async (authProxyBaseURL: string) => {
  const path = '/refresh';
  const ssoInfoSes =
    typeof sessionStorage !== 'undefined' && sessionStorage['sessId'] ? String(sessionStorage['sessId']) : '';
  const refreshSessId = {
    sessionId: ssoInfoSes
  };
  const refreshTokenResponse = await axios.put<RefreshTokenResponse>(
    `${authProxyBaseURL}${path}`,
    JSON.stringify(refreshSessId),
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'session-id': ssoInfoSes
      }
    }
  );
  return refreshTokenResponse?.data;
};

export const sessionManagerRefreshToken = async (
  expireIn: number,
  ohidRefreshTokenBeforeExpireIn: number,
  refreshToken?: string
) => {
  if (expireIn - new Date().getTime() < ohidRefreshTokenBeforeExpireIn) {
    try {
      const refreshTokenResponse = await axios.post<RefreshTokenResponseData>(
        '/api/auth/refresh',
        {
          refreshToken: refreshToken || '',
          region: 'EAST&SOUTH'
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      if (!(refreshTokenResponse.status === 200 && refreshTokenResponse.data?.refId)) {
        throw new Error('Session not found');
      }

      const sessionResponse = await axios.get<SessionResponseData>('/api/auth/session', {
        headers: {
          'Content-Type': 'application/json'
        },
        validateStatus: (status) => status >= 200 && status < 500
      });

      if (!(sessionResponse.status === 200 && sessionResponse.data?.id)) {
        throw new Error('Session not found');
      }
      sessionStorage.setItem('session', JSON.stringify(sessionResponse?.data ?? {}));
      return sessionResponse.data as SessionState;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('error', error);
      sessionStorage.removeItem('session');
      window.location.href = '/api/auth/logout';
      return null;
    }
  }
  return null;
};
